import React from 'react';
import DefaultSelect from '../Default/DefaultSelect';

export default function EhuStatusSelect({onChange, required}) {
    const options = [
        {value: "Ordered", label: "Ordered"},
        {value: "Warehouse JCE, not tested", label: "Warehouse JCE, not tested"},
        {value: "Assembled", label: "Assembled"},
        {value: "Warehouse JCE, OK", label: "Warehouse JCE, OK"},
        {value: "Warehouse JCE, NOK", label: "Warehouse JCE, NOK",},
        {value: "Warehouse IM, not tested", label: "Warehouse IM, not tested"},
        {value: "Warehouse IM, OK", label: "Warehouse IM, OK"},
        {value: "Warehouse IM, NOK", label: "Warehouse IM, NOK"},
        {value: "Shipped", label: "Shipped"},
        {value: "Installed", label: "Installed"},
        {value: "Active", label: "Active"},
        {value: "Warehouse, needs Revision", label: "Warehouse, needs Revision"},
        {value: "Scrap", label: "Scrap"},
        {value: "Needs Repair", label: "Needs Repair"},
        {value: "Offline", label: "Offline"},
    ];

    return (
        <>
            <DefaultSelect required={required} options={options} onChange={(e) => onChange(e)}
                           label="Parts status"/>
        </>
    )
}